import axios from '../../../apis/Api'
import history, { logout } from '../../../history'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import * as XLSX from 'xlsx'
import fileSaver from 'file-saver'

export const GetExportReport = (request, columns = null) => async (dispatch) => {
    dispatch(showLoading());

    try {
        const { data } = await axios.post(`api/DataBaseQueries/GetReportData`, request);

        if (!data.isSuccess) {
            dispatch(hideLoading());
            toast.error(data.Message || data.message || 'Export failed');
            return;
        }

        const outputFilename = `${request.reportName}_${Date.now()}`;
        const dataset = data.response || [];
        const fileTypeXLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

        const ws = XLSX.utils.json_to_sheet(dataset, columns ? { header: columns } : {});
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const fileData = new Blob([excelBuffer], { type: fileTypeXLSX });
        fileSaver.saveAs(fileData, `${outputFilename}.xlsx`);

        dispatch(hideLoading());
        toast.info('File Downloaded', { position: "bottom-right" });

    } catch (error) {
        dispatch(hideLoading());
        if (error.response) {
            if (error.response.status === 401) {
                logout();
                history.push('/login');
                history.go('/login');
            } else if (error.response.data) {
                toast.error(error.response.data.Message || error.response.data.message);
            } else {
                toast.error('Error while processing the request');
            }
        } else {
            toast.error('Network error or request failed');
        }
    }
};
